export const useSxStyles = () => {
  return {
    listRoot: {
      width: '100%',
    },
  };
};
